import {
	RESET_STATE,
	SET_ORDERS_PLANNINGS_LIST,
	SET_IS_ORDERS_PLANNINGS_LIST_LOADING,
	SET_PAGINATION,
	SET_GROUPS,
	SET_IS_GROUPS_LOADING,
	SET_CONFIGS,
	SET_IS_CONFIGS_LOADING,
} from './actions';

export const initialState = {
	ordersPlanningsList: null,
	isOrdersPlanningsListLoading: false,
	pagination: null,
	groups: null,
	isGroupsLoading: false,
	configs: null,
	isConfigsLoading: false,
};

const ordersPlanningsContainerReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_ORDERS_PLANNINGS_LIST:
			return {
				...state,
				ordersPlanningsList: payload,
			};
		case SET_IS_ORDERS_PLANNINGS_LIST_LOADING:
			return {
				...state,
				isOrdersPlanningsListLoading: payload,
			};
		case SET_PAGINATION:
			return {
				...state,
				pagination: payload,
			};
		case SET_GROUPS:
			return {
				...state,
				groups: payload,
			};
		case SET_IS_GROUPS_LOADING:
			return {
				...state,
				isGroupsLoading: payload,
			};
		case SET_CONFIGS:
			return {
				...state,
				configs: payload,
			};
		case SET_IS_CONFIGS_LOADING:
			return {
				...state,
				isConfigsLoading: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default ordersPlanningsContainerReducer;
